import { AppState } from "../../../redux/reducers";
import * as jwt_decode from "jwt-decode";

// store
import * as DebtsStore from "../../../redux/middleware/CashFlow-Debts.Middleware";
import * as PaymentsStore from "../../../redux/middleware/CashFlow-Payments.Middlerware";
import * as PersonsStore from "../../../redux/middleware/Persons.Middleware";

// models
import { Debt } from "../../../models/Entities/CashFlow/Debt/Debt";
import { Payment } from "../../../models/Entities/CashFlow/Payment/Payment";
import { Person } from "../../../models/Entities/Person/Person";
import { ErrorType } from "../../../models/HttpError";

interface IProps {
    /** El centro (tenant) o la entidad desde la que se mira la caja. */
    EntityIdentifier: string;
    /** Con valor, la pantalla es la caja entre el centro y esa entidad (sponsor, proveedor). */
    FixedAssociatedEntityIdentifier: string | undefined;
}

interface ConnectedProps {
  OwnerId: string;
  DebtsAsCreditor: Debt[];
  DebtsAsDebtor: Debt[];
  PaymentsReceived: Payment[];
  PaymentsDone: Payment[];
  isLoadingDebts: boolean;
  isLoadingPayments: boolean;
  debtsLoaded: boolean;
  paymentsLoaded: boolean;
  failOnLoadingDebts: boolean;
  failOnLoadingPayments: boolean;
  errorDebts: ErrorType | undefined;
  errorPayments: ErrorType | undefined;
  isDeletingDebt: boolean;
  isDeletingPayment: boolean;
  // verificación de estado de una deuda saldada
  isCheckingDebtStatus: boolean;
  successCheckingDebtStatus: boolean | undefined;
  debtStatusResult: boolean | undefined;
  checkedDebtStatusId: number | undefined;
  /** Nombre visible de una contraparte, por su identificador. */
  NameOf: (identifier: string) => string;
}

interface DispatchProps {
  GetAllPaymentsByPayer: typeof PaymentsStore.actionCreators.GetAllPaymentsByPayer;
  GetAllPaymentsByReceiver: typeof PaymentsStore.actionCreators.GetAllPaymentsByReceiver;
  GetAllDebtsByCreditor: typeof DebtsStore.actionCreators.GetAllDebtsByCreditor;
  GetAllDebtsByDebtor: typeof DebtsStore.actionCreators.GetAllDebtsByDebtor;
  GetAllPersons: typeof PersonsStore.actionCreators.GetAllPersons;
  DeleteDebt: typeof DebtsStore.actionCreators.DeleteDebt;
  CheckDebtStatus: typeof DebtsStore.actionCreators.CheckDebtStatus;
  DeletePayment: typeof PaymentsStore.actionCreators.DeletePayment;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const MEDICAL_CENTER_NAME = 'Centro Médico';

export const nameOf = (persons: Person[], tenantId: string, identifier: string): string => {
    if (!identifier) return '—';
    if (identifier === tenantId) return MEDICAL_CENTER_NAME;
    return persons.find((person: Person) => person.personIdentifier === identifier)?.businessName || identifier;
};

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const CurrentTenantId = (jwt_decode.jwtDecode(state?.oidc?.user?.access_token!) as any)?.tenantId;
    const persons: Person[] = state.Persons?.list || [];
    const debts = state.CashFlowDebts;
    const payments = state.CashFlowPayments;

    return {
        OwnerId: CurrentTenantId,
        DebtsAsCreditor: debts?.DebtsAsCreditor || [],
        DebtsAsDebtor: debts?.DebtsAsDebtor || [],
        PaymentsReceived: payments?.paymentsReceived || [],
        PaymentsDone: payments?.paymentsDone || [],
        isLoadingDebts: debts?.isLoadingAll || false,
        isLoadingPayments: payments?.isLoadingAll || false,
        debtsLoaded: debts?.successLoadingAll === true || debts?.failOnLoadingAll === true,
        paymentsLoaded: payments?.successLoadingAll === true || payments?.failOnLoadingAll === true,
        failOnLoadingDebts: debts?.failOnLoadingAll || false,
        failOnLoadingPayments: payments?.failOnLoadingAll || false,
        errorDebts: debts?.error,
        errorPayments: payments?.error,
        isDeletingDebt: debts?.isDeletingOne || false,
        isDeletingPayment: payments?.isDeletingOne || false,
        isCheckingDebtStatus: debts?.isCheckingDebtStatus || false,
        successCheckingDebtStatus: debts?.successCheckingDebtStatus,
        debtStatusResult: debts?.debtStatusResult,
        checkedDebtStatusId: debts?.checkedDebtStatusId,
        NameOf: (identifier: string) => nameOf(persons, CurrentTenantId, identifier)
    }
};

export const mapDispatchToProps = {
  GetAllPaymentsByPayer: PaymentsStore.actionCreators.GetAllPaymentsByPayer,
  GetAllPaymentsByReceiver: PaymentsStore.actionCreators.GetAllPaymentsByReceiver,
  GetAllDebtsByCreditor: DebtsStore.actionCreators.GetAllDebtsByCreditor,
  GetAllDebtsByDebtor: DebtsStore.actionCreators.GetAllDebtsByDebtor,
  GetAllPersons: PersonsStore.actionCreators.GetAllPersons,
  DeleteDebt: DebtsStore.actionCreators.DeleteDebt,
  CheckDebtStatus: DebtsStore.actionCreators.CheckDebtStatus,
  DeletePayment: PaymentsStore.actionCreators.DeletePayment
};
